export default __webpack_public_path__ + "static/media/citi.8ddb06d4.svg";